<template>
  <div>
    <el-tabs type="card" v-model="activeTab" class="flex-tabs">
      <el-tab-pane label="题型" name="type">
        <question-type-aside class="px-4" @add="onAdd" />
      </el-tab-pane>
      <el-tab-pane label="大纲" name="outline">
        <template v-slot:label>
          <div class="relative">
            <span>大纲</span>
          </div>
        </template>
        <outline-aside v-if="activeTab === 'outline'" :is-multiple="isMultiple" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import QuestionTypeAside from './QuestionTypeAside'
import OutlineAside from '@/views/survey/edit/aside/OutlineAside'

export default {
  name: 'LeftAside',
  components: { QuestionTypeAside, OutlineAside },
  props: {},
  data() {
    return {
      activeTab: 'type',
      isMultiple: false
    }
  },
  methods: {
    onAdd(item) {
      this.$emit('add', item)
    }
  }
}
</script>

<style scoped></style>
